import React from 'react';
import SmartLink from '@/components/SmartLink';
import { useTracking } from '@mygpt/app/utils';

/**
 * CTASection組件
 * 最終行動召喚区域
 *
 * 包含:
 * - 主標題和副標題
 * - 14日間無料トライアル按鈕
 * - 導入事例PDF下載按鈕
 */
export const CTASection: React.FC = () => {
  const { trackSignupClick } = useTracking();

  return (
    <section
      id="final-cta"
      className="w-full px-4 md:px-10 lg:px-40 py-24 bg-solution-bg-dark text-white relative overflow-hidden"
    >
      {/* 背景装饰 */}
      <div className="absolute inset-0 bg-solution-orange/10 opacity-30"></div>

      <div className="max-w-[960px] mx-auto text-center relative z-10">
        <p className="text-solution-orange font-bold text-sm uppercase tracking-wider mb-4">
          大型商業施設で実証済みのAIを導入
        </p>

        <h2 className="text-3xl md:text-5xl font-bold mb-6">
          今日から案内所の負担を
          <br className="md:hidden" />
          <span className="text-solution-orange">大幅削減</span>
        </h2>

        <p className="text-lg text-gray-300 mb-10 max-w-2xl mx-auto">
          14日間の無料トライアルで、効果を実感してください。
          <br />
          専用端末不要・クレジットカード登録不要・最短1週間で導入完了。
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <SmartLink
            to="/register"
            className="flex items-center justify-center rounded-lg h-14 px-8 bg-solution-orange hover:bg-solution-orange-dark transition-colors text-white text-lg font-bold shadow-lg shadow-solution-orange/30"
            onClick={() => trackSignupClick('final_cta')}
          >
            14日間無料トライアル開始
          </SmartLink>

          {/* Hidden temporarily - will be moved to case study page
          <SmartLink
            href="https://cs.gbase.ai/download"
            target="_blank"
            className="flex items-center justify-center rounded-lg h-14 px-8 bg-transparent border border-gray-600 hover:border-white hover:bg-white/5 transition-colors text-white text-lg font-bold"
          >
            導入事例PDFを入手
          </SmartLink>
          */}
        </div>
      </div>
    </section>
  );
};

export default CTASection;
